/**
 * Which part of the company area a route belongs to, for the company side nav.
 *
 * Pure so it can be specified without mounting the nav. The sections follow the
 * breadcrumb trails: every company page's trail starts at Company Dashboard, and
 * the nav marks the section the page sits in.
 *  - Directory: the members directory.
 *  - Company Settings: the settings page and every page under
 *    `/team/company-settings` (Team Roles, Company Roles, SSO and SCIM, and any
 *    added later, since the path decides rather than a list of names).
 *  - Company Dashboard: everything else in the area. A team's page and a
 *    member's page are reached from the dashboard, and their trails run through
 *    it; the reports are opened from its cards.
 */
import { ROUTER } from '@/router/constants';

export const COMPANY_NAV_SECTION = {
	DASHBOARD: 'dashboard',
	SETTINGS: 'settings',
	DIRECTORY: 'directory',
} as const;

export type CompanyNavSection = typeof COMPANY_NAV_SECTION[keyof typeof COMPANY_NAV_SECTION];

/** The directory's name wherever it is shown: its heading, its tab title, its crumb, and the nav. */
export const COMPANY_DIRECTORY_TITLE: string = 'Directory';

const COMPANY_SETTINGS_PATH: string = '/team/company-settings';

export interface CompanyNavRoute {
	name?: string | null;
	path?: string | null;
}

export function companyNavSection(route: CompanyNavRoute | null | undefined): CompanyNavSection {
	const name: string = (route && route.name) || '';
	const path: string = (route && route.path) || '';
	if (name === ROUTER.MEMBERS_DIRECTORY) return COMPANY_NAV_SECTION.DIRECTORY;
	if (name === ROUTER.COMPANY_SETTINGS || path === COMPANY_SETTINGS_PATH || path.indexOf(`${COMPANY_SETTINGS_PATH}/`) === 0) {
		return COMPANY_NAV_SECTION.SETTINGS;
	}
	return COMPANY_NAV_SECTION.DASHBOARD;
}
